export const detailUrl = ({ id }) => {
  return `/buildings/detail/${id}`;
};

export const overviewUrl = () => {
  return `/buildings`;
};

export const constructStrRep = (obj) => obj?.str_representation;
